import Card from "@mui/joy/Card";
import {Stack} from "@mui/joy";

// component Cards
import TaskCard from "../Cards/TaskCard";
import OpportunityCard from "../Cards/OpportunityCard";
import AccountCard from "../Cards/AccountCard";
import ContactCard from "../Cards/ContactCard";
import DeliveryCard from "../Cards/DeliveryCard";
import RouteCard from "../Cards/RouteCard";
import FeatureRequestCard from "../Cards/FeatureRequestCard";
import BaseApi from "../../utils/BaseApi";
import ComponentCard from "./ComponentCard";
import LeadCard from "../Cards/LeadCard";
import CommunicationCard from "../Cards/CommunicationCard";
import ApplicantCard from "../Cards/ApplicantCard";
import PaymentCard from "../Cards/PaymentCard";
import CertificateCard from "../Cards/CertificateCard";
import CommentItem from "../Comment/CommentItem";
import EstimationPhaseCard from "../Estimation/EstimationPhaseCard";
import SliceCard from "../Slice/SliceCard";
import CallCard from "../Communication/CallCard";
import WikiPageCard from "../Cards/WikiPageCard";
import retrievePermission from "../../utils/retrievePermission";


export const openSidebar = () => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
    }
};

export const closeSidebar = () => {
    if (typeof document !== 'undefined') {
        document.documentElement.style.removeProperty('--SideNavigation-slideIn');
        document.body.style.removeProperty('overflow');
    }
};

export const toggleSidebar = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        const slideIn = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--SideNavigation-slideIn');
        if (slideIn) {
            closeSidebar();
        } else {
            openSidebar();
        }
    }
};


export function camelToSnakeCase(str){
    let s = str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    if (Array.from(s)[0] === '_'){
        s = s.substring(1);
    }
    return s
}


export async function retrieveEntity(entity, id) {
    const url = `${camelToSnakeCase(entity)}/${id}`;
    const api = new BaseApi();
    let response = await api.get(url, {});
    if (response.status < 300){
        return response.data
    }
}


export async function retrieveComponentCard(entity, entity_id, mini, nano) {
    let component;
    let title;
    switch (entity) {
        case 'Task':
            let task = await retrieveEntity(
                entity,
                entity_id
            )
            if (task){
                component = <TaskCard
                    task={task}
                />
                title = 'Задача'
            }
            break;
        case 'Comment':
            let comment = await retrieveEntity(
                entity,
                entity_id
            )
            if (comment){
                component = <Stack spacing={2}>
                    <CommentItem
                        comment={comment}
                        key={'comment-item-' + comment.id}
                        inlineReply={true}
                    />
                    <ComponentCard
                        entity={comment.related_app}
                        entity_id={comment.related_app_id}
                        mini={mini}
                    />
                </Stack>
                title = 'Комментарий'
            }
            break;
        case 'Opportunity':
            component = <OpportunityCard
                opportunityID={entity_id}
                mini
                nano
            />
            title = 'Сделка'
            break;
        case 'Account':
            let account = await retrieveEntity(
                entity,
                entity_id
            )
            if (account){
                component = <AccountCard
                    account={account}
                    mini
                    nano
                />
                title = 'Компания'
            }
            break;
        case 'Contact':
            let contact = await retrieveEntity(
                entity,
                entity_id
            )
            if (contact){
                component = <ContactCard
                    contact={contact}
                    mini={mini}
                />
                title = 'Контакт'
            }
            break;
        case 'DeliveryState':
            let delivery;
            let deliveryState = await retrieveEntity(
                entity,
                entity_id
            )
            if (deliveryState){
                delivery = await retrieveEntity(
                    'Delivery',
                    deliveryState.delivery.id
                )
            }
            if (delivery){
                let dcePermission = await retrievePermission(
                    'DeliveryControlledEntityViewSet',
                    'create',
                    this.context.subscriberObject
                )
                let updatePermission = await retrievePermission(
                    'DeliveryViewSet',
                    'partial_update',
                    this.context.subscriberObject
                )
                component = <DeliveryCard
                    dcePermission={dcePermission}
                    updatePermission={updatePermission}
                    delivery={delivery}
                />
                title = 'Бизнес-процесс'
            }
            break;
        case 'RouteState':
            let routeState = await retrieveEntity(
                entity,
                entity_id
            )
            if (routeState){
                component = <RouteCard
                    route={routeState.route}
                />
                title = 'Маршрут'
            }
            break;
        case 'FeatureRequest':
            let featureRequest = await retrieveEntity(
                entity,
                entity_id
            )
            if (featureRequest) {
                component = <FeatureRequestCard
                    featureRequest={featureRequest}
                />
                title = 'Тех. поддержка'
            }
            break;
        case 'Lead':
            let lead = await retrieveEntity(
                entity,
                entity_id
            )
            if (lead){
                component = <LeadCard
                    lead={lead}
                    mini
                    nano
                />
                title = 'Входящий запрос'
            }
            break;
        case 'Communication':
            let communication = await retrieveEntity(
                entity,
                entity_id
            )
            if (communication){
                let parent = retrieveComponentCard(
                    communication.related_app,
                    communication.related_app_id,
                    mini
                )

                component = <Card>
                    {parent?parent:null}
                    <CommunicationCard
                        communication={communication}
                        mini={mini}
                    />
                </Card>
            }
            title = 'Способ связи'
            break;
        case 'Requisites':
            let requisites = await retrieveEntity(
                entity,
                entity_id
            )
            if (requisites){
                return retrieveComponentCard(
                    'Account',
                    requisites.account,
                )
            }
            break;
        case 'Applicant':
            let applicant = await retrieveEntity(
                entity,
                entity_id
            )
            if (applicant){
                component = <ApplicantCard
                    applicant={applicant}
                />
                title = 'Соискатель'
            }
            break;
        case 'EstimationPhase':
            let phase = await retrieveEntity(
                entity,
                entity_id
            )
            if (phase){
                component = <>
                    <ComponentCard
                        entity='Opportunity'
                        entity_id={phase.revision_fk.opportunity}
                        nano={true}
                    />
                    <EstimationPhaseCard
                        phase={phase}
                    />

                </>
                title = 'Этап трудоемкости'
            }
            break;
        case 'Slice':
            let slice = await retrieveEntity(
                entity,
                entity_id
            )
            if (slice){
                component = <>
                    <ComponentCard
                        entity='Opportunity'
                        entity_id={slice.opportunity.id}
                        nano={true}
                    />
                    <SliceCard
                        slice={slice}
                    />
                </>
                title = 'Срез'
            }
            break;
        case 'OppPayment':
            let payment = await retrieveEntity(
                'Payment',
                entity_id
            )
            if (payment){
                component = <PaymentCard
                    payment={payment}
                />
                title = 'Входящий платеж'
            }
            break;
        case 'OppCert':
            let certificate = await retrieveEntity(
                'Certificate',
                entity_id
            )
            if (certificate){
                component = <CertificateCard
                    certificate={certificate}
                />
                title = 'Акт'
            }
            break;
        case 'SunsimCall':
            let sunsimCall = await retrieveEntity(
                entity,
                entity_id
            )
            if (sunsimCall){
                component = <CallCard
                    call={sunsimCall}
                    showCommunications={true}
                />
                title = 'Звонок'
            }
            break;
        case 'WikiPage':
            let wikiPage = await retrieveEntity(
                'WikiPage',
                entity_id
            )
            if (wikiPage){
                component = <WikiPageCard
                    wikiPage={wikiPage}
                />
                title = 'Wiki страница'
            }
            break;
        default:
            break;
    }
    if (component){
        return [component, title]
    }
    return (
        <></>
    )
}
